import React from "react";
import { createImageFromInitials } from "../../AgentLogo";
import Avatar from "../../static/images/lisa.png";

export default function HealthChatHeader({ agentName, showModal, messageCounter, botName, miniMize, mobileClass }) {
  return (
    <header>
      {agentName ?
        <img
          id='preview'
          src={
            createImageFromInitials(500, agentName, "blue")  //getRandomColor()
          }
          alt='profile-pic'
        />
        :
        <img src={Avatar} alt=""></img>
      }
      <div>
        <h2>{agentName ? agentName : botName || "Policybazaar"}</h2>
      </div>
      <div>
        {messageCounter > 0 ? messageCounter : null}
      </div>
      {mobileClass? 
      
      <div onClick={() => miniMize()} className="closeIconForMobile"></div>
      
    :<>
      <div onClick={() => showModal()} className="closeIcon">&#x2715;</div>
      <div onClick={() => miniMize()} className="minimizeIcon">&minus;</div>
    </>}
    </header>
  );
}
